@if (displayMode() === 'edit') {
    @if (displayMode() === 'edit') {
        <mulo-context-frame
            (close)="handleFormClose()"
            (open)="handleFormOpen()"
            [isOpen]="formMode() === 'edit' || formMode() === 'add'"
            [showOpenBtn]="localFieldNames().length > 0"
            btnLabel="{{ 'research.project.page.add.additional.field' | translate }}"
        >
            <form (ngSubmit)="handleSubmit()" [formGroup]="form">
                <div class="fields-grouping overflow-hidden">
                    <mat-form-field class="spacer">
                        <mat-label>{{ 'research.project.page.add.section.item.field.name' | translate }}</mat-label>
                        <mat-select #elementFocus formControlName="code">
                            @for (source of localFieldNames(); track source) {
                                <mat-option [value]="source" [disabled]="uniqueCodes() && codeExists(source)">{{
                                    source | translate
                                }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="spacer">
                        <mat-label> {{ 'research.project.page.add.section.item.value' | translate }}</mat-label>
                        <input
                            #idValueInput
                            autocomplete="off"
                            formControlName="localFieldValue"
                            matInput
                            required
                            type="text"
                        />
                        <mat-error
                            [innerHtml]="'research.settings.field.required.error.message' | translate"
                        ></mat-error>
                    </mat-form-field>
                </div>
                <div class="form-actions">
                    <button
                        (click)="handleAddAnother($event)"
                        [disabled]="!form?.valid || submitInProgress()"
                        mat-button
                    >
                        {{ 'research.project.page.add.another.local.field' | translate }}
                    </button>
                    <button
                        [disabled]="!form?.valid || submitInProgress()"
                        class="is-tight margin-left-sm"
                        mat-raised-button
                        type="submit"
                    >
                        {{
                            (formMode() === 'add'
                                ? 'research.portal.entity.item.add'
                                : 'research.portal.entity.item.save'
                            ) | translate
                        }}
                    </button>
                </div>
            </form>
        </mulo-context-frame>
    }
    @if (items()?.length) {
        @let screenGtSm = media.state()['gt-sm'];

        <mat-list class="mulo-elevation-list" role="list">
            @for (field of items(); track field; let i = $index) {
                <mulo-action-list-item
                    [disabled]="i == itemInEdit()"
                    [moreBtnLabel]="'research.aria.output.list.menu.more.options' | translate"
                    class="mulo-elevation-list-item is-wrapping"
                    role="listitem"
                    [actions]="[
                        localFieldNames().includes(field.code)
                            ? {
                                  type: 'icon-btn',
                                  icon: screenGtSm ? 'pencil' : null,
                                  labels: [
                                      'research.aria.edit.button' | translate: { value: (field.code | translate) },
                                  ],
                                  actionEvent: setForm.bind(this, i),
                              }
                            : null,
                        showRemoveBtn() && !requiredFields().includes(field.code)
                            ? {
                                  type: 'icon-btn',
                                  icon: screenGtSm ? 'close' : null,
                                  labels: [
                                      'research.aria.deposit.portion.remove'
                                          | translate
                                              : {
                                                    value: (field.code | translate),
                                                },
                                  ],
                                  actionEvent: removeField.bind(this, i),
                              }
                            : null,
                    ]"
                >
                    <span matLine>
                        <span class="field-code"
                            >{{ field.code | translate }}
                            @if (requiredFields().includes(field.code)) {
                                <span class="required-field">
                                    <mat-icon svgIcon="asterisk"></mat-icon>
                                    {{ 'research.deposit.required' | translate }}</span
                                >
                            }
                        </span>
                        <span [innerHTML]="field.localFieldValue" class="field-value">{{ field.localFieldValue }}</span>
                    </span>
                </mulo-action-list-item>
            }
        </mat-list>
    }
} @else {
    <mulo-expandable
        [collapseLabel]="'research.portal.fulldisplay.details.collapse' | translate"
        [expandLabel]="'research.portal.fulldisplay.details.showTheRest' | translate"
        [ratio]="8"
        class="padding-top-xs"
    >
        <mulo-dictionary [display]="media.state()['gt-xs'] ? 'auto-rows' : 'column'">
            @for (field of items(); track field; let i = $index) {
                <div [content]="field.localFieldValue" [label]="field.code | translate" mulo-dictionary-item></div>
            }
        </mulo-dictionary>
    </mulo-expandable>
}
